import React from 'react';

import { TCustomInputTheme } from 'types/state';
import { CustomInputNativeTextAreaComponent } from 'design/customInput/customInputNativeTextAreaComponents';
import { CustomInputNativeInputComponent } from 'design/customInput/customInputNativeInputComponents';
import { FloatingLabelComponent } from 'design/floatingLabel';
import { TextComponent } from 'design/text/textComponents';

type Props = {
  name: string;
  placeholder: string;
  value?: string;
  type?: 'email' | 'password' | 'text';
  autoFocus?: boolean;
  multiline?: boolean;
  theme?: TCustomInputTheme;
  errorMessage?: string;
  hintMessage?: string;
  inputTestId?: string;
  errorTestId?: string;
  hintTestId?: string;
  maxLength?: number;
  onChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void;
};

export function CustomInputComponent(props: Props) {
  const {
    placeholder,
    multiline,
    errorMessage,
    hintMessage,
    inputTestId,
    errorTestId,
    hintTestId,
    theme,
    ...forwardProps
  } = props;

  return (
    <FloatingLabelComponent
      lifted={!!forwardProps.value}
      invalid={!!errorMessage}
      titleText={
        <TextComponent color="secondary" size="m">
          {placeholder}
        </TextComponent>
      }
      hintText={
        hintMessage ? (
          <TextComponent color="secondary" size="s">
            {hintMessage}
          </TextComponent>
        ) : (
          <TextComponent color="critical" size="s">
            {errorMessage}
          </TextComponent>
        )
      }
    >
      {multiline ? (
        <CustomInputNativeTextAreaComponent
          {...forwardProps}
          invalid={!!errorMessage}
          placeholder={placeholder}
          testId={inputTestId}
        />
      ) : (
        <CustomInputNativeInputComponent
          {...forwardProps}
          invalid={!!errorMessage}
          placeholder={placeholder}
          testId={inputTestId}
        />
      )}
    </FloatingLabelComponent>
  );
}
